/* eslint-disable react-hooks/exhaustive-deps */
import {
  ActionCardProps,
  ActionsProps,
  EnquiryHandle,
  Product,
  RightPanelTabs,
  RightPanelTabsConfiguration,
} from '@access-erp/common';
import { CardType, IRowNode } from '@access-erp/ui-components';
import { useMemo, useState } from 'react';

import { UserRole } from '@/config/roles.config';
import { PaginatedFilteredUpliftType, UpliftStatusEnum } from '@/graphql/contracts/_generated_/contracts';
import { UpliftTypeWithId } from '@/utils/data-helpers/types';

type ActionButton = {
  config: ActionCardProps;
  isVisible: boolean;
};

interface UseRightPanelParams {
  selectedHeaderRows: IRowNode<PaginatedFilteredUpliftType>[];
  gridRef?: EnquiryHandle<UpliftTypeWithId>;
  userRole: UserRole;
}

export function useRightPanel({ selectedHeaderRows, userRole }: UseRightPanelParams) {
  const [isVisibleCancelUpliftModal, setIsVisibleCancelUpliftModal] = useState(false);

  const allSelectedLinesArePending = useMemo(() => {
    return (
      selectedHeaderRows.length > 0 &&
      selectedHeaderRows.every(
        (u: IRowNode<PaginatedFilteredUpliftType>) => u.data && u.data.status === UpliftStatusEnum.Pending,
      ) &&
      (userRole === UserRole.ADMIN || userRole === UserRole.FULL_ACCESS)
    );
  }, [selectedHeaderRows]);

  const actionButtons = useMemo<ActionButton[]>(
    () => [
      {
        config: {
          text: 'Cancel Uplift',
          cardType: CardType.ACTION,
          product: Product.ContractsAndBilling,
          onClick: () => setIsVisibleCancelUpliftModal(true),
        },
        isVisible: allSelectedLinesArePending,
      },
    ],
    [selectedHeaderRows],
  );

  const actionsParams: ActionsProps = {
    actionCards: {
      actions: actionButtons.filter((el) => el.isVisible).map((el) => el.config),
    },
  };

  const tabsConfiguration = useMemo<RightPanelTabsConfiguration>(
    () => ({
      [RightPanelTabs.ACTIONS]: actionsParams,
    }),
    [selectedHeaderRows],
  );

  return {
    tabsConfiguration,
    closeCancelUpliftModal: () => setIsVisibleCancelUpliftModal(false),
    isVisibleCancelUpliftModal,
  };
}
